export enum InternalMessageTypes {
  LOGIN_OR_SIGNUP_ERROR = 'LOGIN_OR_SIGNUP_ERROR',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  CLEAR_ERROR = 'CLEAR_ERROR',
  LOGOUT = 'LOGOUT',
  CLEAR_MESSAGES = 'CLEAR_MESSAGES',
  FINISHED_GAMES = 'FINISHED_GAMES',
  ARCHIVED_GAMES = 'ARCHIVED_GAMES',
  SOCKET_CONNECTED = 'SOCKET_CONNECTED',
  SOCKET_DISCONNECTED = 'SOCKET_DISCONNECTED',
  SUBSCRIPTION_REGISTERED = 'SUBSCRIPTION_REGISTERED',
  SET_LANGUAGE = 'SET_LANGUAGE',
  UPDATE_EMAIL = 'UPDATE_EMAIL',
  TOKEN_REFRESHED = 'TOKEN_REFRESHED',
}
